import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  LOGISTICS_MANAGE_VACATIONS_REPOSITORY,
  LogisticsManageVacationsRepository
} from '@app/domain/repositories/manage-vacations/logistics/logistics-manage-vacations.repository.contract';
import { ManageVacationsCriteria } from '@app/entities/models/manage-vacations/manage-vacations-criteria.model';
import {
  EmployeeObservations,
  SeasonCalendar,
  VacationsSeason
} from '@app/entities/models/manage-vacations/manage-vacations.model';
import { TUserTypeCalendarProposal } from '@app/entities/types/manage-vacations.type';

import { LogisticsManageVacationsUseCases } from './logistics-manage-vacations.use-cases.contract';

import {
  LogisticsCalendarEvent,
  LogisticsProposal,
  LogisticsVacationsProposal
} from '@/models/manage-vacations/logistics-manage-vacations.model';

@Injectable({
  providedIn: 'root'
})
export class LogisticsManageVacationsUseCasesImpl implements LogisticsManageVacationsUseCases {
  #manageVacationsRepository: LogisticsManageVacationsRepository = inject(LOGISTICS_MANAGE_VACATIONS_REPOSITORY);

  getProposals(): Observable<LogisticsVacationsProposal> {
    return this.#manageVacationsRepository.getProposals();
  }

  getVacationsCriteria(): Observable<ManageVacationsCriteria> {
    return this.#manageVacationsRepository.getVacationsCriteria();
  }

  getVacationsSeason(): Observable<VacationsSeason> {
    return this.#manageVacationsRepository.getVacationsSeason();
  }

  getCalendar(): Observable<SeasonCalendar<TUserTypeCalendarProposal>> {
    return this.#manageVacationsRepository.getCalendar();
  }

  getDayDetail(day: string): Observable<LogisticsCalendarEvent[]> {
    return this.#manageVacationsRepository.getDayDetail(day);
  }

  createProposal(
    holidays: LogisticsProposal[],
    freeByHolidays: LogisticsProposal[],
    isDraft: boolean
  ): Observable<LogisticsVacationsProposal> {
    return this.#manageVacationsRepository.createProposal(holidays, freeByHolidays, isDraft);
  }

  updateObservations(observations: string): Observable<EmployeeObservations> {
    return this.#manageVacationsRepository.updateObservations(observations);
  }
}
